module.exports = __webpack_public_path__ + "img/carousel-1.306c77b8.jpg";